import type { DBConversationResponse } from '@/types/api';
import { Card } from '@/components/ui/card';
import { ConversationItem } from './ConversationItem';

export interface ConversationsListProps {
  conversations: DBConversationResponse[] | undefined;
}

export const ConversationsList = ({
  conversations,
}: ConversationsListProps) => {
  if (!conversations || conversations.length === 0) {
    return null;
  }

  return (
    <Card className='mt-2 gap-0'>
      <div className='p-4 border-b flex items-center justify-between'>
        <h2 className='text-sm font-medium'>Conversations</h2>
      </div>
      <div className='p-4 space-y-3'>
        {conversations.map(conversation => (
          <ConversationItem key={conversation.id} conversation={conversation} />
        ))}
      </div>
    </Card>
  );
};
